import { ProgramCountryLead } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramCountryLeads: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  accessToken?: string,
) => Promise<ProgramCountryLead[]> = (fetchContext, programId, countryId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/leads`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<ProgramCountryLead[]>(fetchContext.errorStore, response, 'get program country leads'));
